import { usingGet } from '@ocean/api'

export const getConfiguration = () => usingGet('environment/configuration', { useProxy: true })

export const getNotificationsNumbers = () => usingGet('Environment/GetNotificationsNumbers')
